import { GUIDES, isDraftGuide, type Guide } from "@/lib/guides";

export const GUIDE_CATEGORIES = ["Conveyancing", "Business & Commercial", "Wills & Estates", "Elder Law"] as const;
export type GuideCategoryFilter = Guide["category"] | "All";

export function validateGuideFilter(query: unknown, category: unknown): asserts category is GuideCategoryFilter {
  if (typeof query !== "string" || query.length > 200) throw new Error("Search must be text of at most 200 characters.");
  if (category !== "All" && !GUIDE_CATEGORIES.some((value) => value === category)) throw new Error("Unknown guide category.");
}

export function searchPublicGuides(query: string, category: GuideCategoryFilter) {
  validateGuideFilter(query, category);
  const search = query.trim().toLowerCase();
  return GUIDES.filter((guide) => !isDraftGuide(guide.slug)
    && (category === "All" || guide.category === category)
    && (!search || `${guide.title} ${guide.description}`.toLowerCase().includes(search)));
}

export function guideLinkText(guides: readonly Guide[], limit = 10) {
  if (!guides.length) return "No published guides match this search.";
  return guides.slice(0, limit).map((guide) => `${guide.title} — https://coastsidelaw.com.au/guides/${guide.slug}`).join("\n");
}